import { render, staticRenderFns } from "./RechargePage.vue?vue&type=template&id=6a34cd04&scoped=true"
import script from "./RechargePage.vue?vue&type=script&lang=js"
export * from "./RechargePage.vue?vue&type=script&lang=js"
import style0 from "./RechargePage.vue?vue&type=style&index=0&id=6a34cd04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a34cd04",
  null
  
)

export default component.exports